import React from "react";

import { Form } from "@weezevent/nacre";
import { useController, useFormContext } from "react-hook-form";
import PropTypes from "prop-types";

/**
 * This component is an input to manage a toggle (switch) value.
 * It's a controlled field that deals with react-hook-form. Must be wrapped by a FormContext.
 */
const FormFieldCheckbox = ({
	name,
	label,
	control: controlProp,
	onChange: onExternalChange,
	...props
}) => {
	// Get control from context if not provided as prop
	const formContext = useFormContext();
	const control = controlProp || (formContext && formContext.control);

	const {
		field: { onChange, value },
		fieldState: { error }
	} = useController({
		name: name,
		control
	});

	const onChangeValue = React.useCallback(
		e => {
			onChange(e.target.checked);
			onExternalChange(e.target.checked);
		},
		[onChange, onExternalChange]
	);

	return (
		<Form.CheckboxLabel
			name={name}
			label={label}
			value={value}
			onChange={onChangeValue}
			errors={!!error}
			{...props}
		/>
	);
};

FormFieldCheckbox.propTypes = {
	/**
	 * The name of the checkbox. This name must be unique in the form.
	 * Used by react-hook-form.
	 */
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	control: PropTypes.object,
	onChange: PropTypes.func
};

FormFieldCheckbox.defaultProps = {
	label: "",
	control: null,
	onChange: () => {}
};

export default FormFieldCheckbox;
